export const siteInfo = {
  name: '奶水动漫',
  tagline: '专属母婴哺乳主题动漫内容平台',
  description: '奶水动漫是专注母婴哺乳主题的动漫内容平台，汇聚哺乳育儿动漫故事、母婴科普漫画、萌宝成长动画等优质内容，帮助新手妈妈轻松了解哺乳知识，寓教于乐，陪伴每一位妈妈的育儿旅程。',
  email: 'hello@naishuidongman.com',
  phone: '400-888-6688',
  address: '北京市朝阳区望京SOHO T1-A座 1508室',
  wechat: 'naishuidongman',
  weibo: '@奶水动漫官方',
};

export const categories = [
  { slug: 'buru-yuer', name: '哺乳育儿', icon: 'ri-heart-pulse-line', description: '哺乳育儿动漫故事，温馨感人的亲子时光' },
  { slug: 'kepu-manhua', name: '科普漫画', icon: 'ri-book-read-line', description: '母婴哺乳科普漫画，专业知识轻松学' },
  { slug: 'mengbao-chengzhang', name: '萌宝成长', icon: 'ri-emotion-happy-line', description: '萌宝成长动画，记录宝宝每一个精彩瞬间' },
  { slug: 'muru-weiyang', name: '母乳喂养', icon: 'ri-drop-line', description: '母乳喂养动漫指南，科学喂养全攻略' },
  { slug: 'xinshou-mama', name: '新手妈妈', icon: 'ri-user-heart-line', description: '新手妈妈专属漫画，陪你度过育儿第一年' },
];

export const featuredArticles = [
  {
    id: '1',
    slug: 'buru-zhengque-zishi',
    title: '哺乳正确姿势全攻略：让妈妈和宝宝都舒适',
    category: 'buru-yuer',
    categoryName: '哺乳育儿',
    excerpt: '掌握正确的哺乳姿势是母乳喂养成功的关键。本期漫画带你了解四种经典哺乳姿势，帮助新手妈妈轻松上手。',
    coverImage: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20illustration%20of%20a%20mother%20gently%20breastfeeding%20her%20baby%20in%20a%20cozy%20warm%20nursery%20room%20with%20soft%20natural%20lighting%20pastel%20colors%20gentle%20atmosphere%20watercolor%20texture%20Japanese%20manga%20aesthetic&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '奶水动漫编辑部',
    date: '2026-08-08',
    readTime: '8分钟',
    tags: ['哺乳姿势', '新手教程', '母乳喂养'],
    isHot: true,
  },
  {
    id: '2',
    slug: 'muru-chengfen-jiexi',
    title: '母乳成分大揭秘：每一滴都是爱的精华',
    category: 'kepu-manhua',
    categoryName: '科普漫画',
    excerpt: '母乳中到底含有哪些神奇的营养成分？跟随我们的科普漫画，一起探索母乳的科学奥秘。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20scientific%20illustration%20showing%20microscopic%20view%20of%20nutrients%20in%20breast%20milk%20with%20colorful%20cells%20and%20vitamins%20floating%20in%20a%20gentle%20pastel%20background%20educational%20manga%20style&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '营养科普小组',
    date: '2026-08-06',
    readTime: '10分钟',
    tags: ['母乳成分', '营养科普', '科学喂养'],
    isHot: true,
  },
  {
    id: '3',
    slug: 'baobao-fushi-guodu',
    title: '宝宝辅食过渡指南：从母乳到餐桌',
    category: 'mengbao-chengzhang',
    categoryName: '萌宝成长',
    excerpt: '宝宝什么时候开始添加辅食？怎么添加才科学？用趣味动漫告诉你辅食过渡的全部秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Adorable%20anime%20baby%20sitting%20in%20a%20high%20chair%20trying%20colorful%20baby%20food%20with%20a%20happy%20expression%20warm%20kitchen%20background%20soft%20pastel%20colors%20cute%20manga%20illustration%20style&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '萌宝成长记',
    date: '2026-08-04',
    readTime: '12分钟',
    tags: ['辅食添加', '宝宝成长', '喂养过渡'],
    isHot: true,
  },
  {
    id: '4',
    slug: 'yedu-buru-jiqiao',
    title: '夜哺不崩溃：夜间哺乳实用技巧漫画',
    category: 'buru-yuer',
    categoryName: '哺乳育儿',
    excerpt: '夜间哺乳是很多新手妈妈的最大挑战。这组漫画教你如何应对夜哺，让妈妈也能睡个好觉。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20mother%20breastfeeding%20her%20baby%20at%20night%20in%20a%20dimly%20lit%20bedroom%20with%20soft%20moonlight%20through%20the%20window%20peaceful%20atmosphere%20gentle%20pastel%20colors%20warm%20cozy%20feeling&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '奶水动漫编辑部',
    date: '2026-08-02',
    readTime: '6分钟',
    tags: ['夜间哺乳', '实用技巧', '新手妈妈'],
    isHot: false,
  },
  {
    id: '5',
    slug: 'rufang-huli-zhishi',
    title: '哺乳期乳房护理知识：妈妈必知的五个要点',
    category: 'kepu-manhua',
    categoryName: '科普漫画',
    excerpt: '哺乳期乳房护理至关重要。通过轻松有趣的漫画，学习乳房护理的正确方法。',
    coverImage: 'https://readdy.ai/api/search-image?query=Educational%20anime%20style%20illustration%20about%20breast%20care%20during%20nursing%20period%20with%20gentle%20nursing%20mother%20character%20in%20a%20bright%20bathroom%20setting%20soft%20warm%20colors%20clean%20aesthetic%20Japanese%20manga%20style&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '护理知识库',
    date: '2026-07-30',
    readTime: '9分钟',
    tags: ['乳房护理', '哺乳知识', '妈妈健康'],
    isHot: false,
  },
  {
    id: '6',
    slug: 'naishui-chansheng-yuanli',
    title: '奶水是怎样产生的？一部漫画搞懂泌乳原理',
    category: 'muru-weiyang',
    categoryName: '母乳喂养',
    excerpt: '很多妈妈好奇奶水到底是怎么来的。这部科普漫画用最直观的方式告诉你泌乳的全过程。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20educational%20illustration%20showing%20the%20process%20of%20lactation%20in%20a%20mother%20body%20with%20cute%20diagram%20style%20and%20soft%20pastel%20pink%20background%20gentle%20scientific%20manga%20aesthetic%20warm%20colors&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '泌乳科普组',
    date: '2026-07-28',
    readTime: '7分钟',
    tags: ['泌乳原理', '科学科普', '母乳知识'],
    isHot: false,
  },
];

export const latestArticles = [
  {
    id: '7',
    slug: 'chanhou-yinshi-tiaoli',
    title: '产后饮食调理：哺乳妈妈的一日三餐',
    category: 'xinshou-mama',
    categoryName: '新手妈妈',
    excerpt: '产后吃什么才能奶水充足又不会发胖？这份漫画食谱请收好！',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20nutritious%20postpartum%20meals%20on%20a%20dining%20table%20with%20a%20happy%20nursing%20mother%20eating%20healthy%20food%20warm%20kitchen%20atmosphere%20soft%20pastel%20colors%20cute%20manga%20aesthetic&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '营养科普小组',
    date: '2026-08-09',
    readTime: '11分钟',
    tags: ['产后饮食', '哺乳期食谱', '营养搭配'],
  },
  {
    id: '8',
    slug: 'baobao-zhangya-shiqi',
    title: '宝宝长牙期哺乳指南：如何应对咬乳头',
    category: 'mengbao-chengzhang',
    categoryName: '萌宝成长',
    excerpt: '宝宝长牙期喜欢咬东西，哺乳时被咬怎么办？别急，这里有一份完整应对方案。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20anime%20baby%20with%20first%20tooth%20smiling%20while%20a%20gentle%20mother%20character%20guides%20breastfeeding%20in%20a%20bright%20nursery%20soft%20pastel%20colors%20warm%20and%20playful%20manga%20illustration&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '萌宝成长记',
    date: '2026-08-09',
    readTime: '8分钟',
    tags: ['长牙期', '哺乳技巧', '宝宝发育'],
  },
  {
    id: '9',
    slug: 'gonggong-changhe-buru',
    title: '公共场合哺乳攻略：妈妈不必尴尬',
    category: 'xinshou-mama',
    categoryName: '新手妈妈',
    excerpt: '在公共场合哺乳是每位妈妈的权利。这篇漫画告诉你如何优雅自在地在外哺乳。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20confident%20mother%20breastfeeding%20her%20baby%20in%20a%20public%20park%20setting%20with%20a%20nursing%20cover%20surrounded%20by%20soft%20nature%20background%20warm%20empowering%20atmosphere%20gentle%20colors&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '奶水动漫编辑部',
    date: '2026-08-07',
    readTime: '7分钟',
    tags: ['公共哺乳', '妈妈权益', '社会话题'],
  },
  {
    id: '10',
    slug: 'duanru-shijian-xuanze',
    title: '断奶时间怎么选？漫画版断奶全攻略',
    category: 'buru-yuer',
    categoryName: '哺乳育儿',
    excerpt: '什么时候断奶最合适？自然离乳还是引导断奶？这篇漫画给你最全面的答案。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20showing%20a%20toddler%20transitioning%20from%20breastfeeding%20to%20drinking%20from%20a%20cup%20with%20mother%20gently%20guiding%20warm%20home%20setting%20soft%20emotional%20tone%20pastel%20colors%20gentle%20manga%20style&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '育儿专家团',
    date: '2026-08-05',
    readTime: '15分钟',
    tags: ['断奶', '自然离乳', '育儿经验'],
  },
  {
    id: '11',
    slug: 'buruqi-yundong-zhinan',
    title: '哺乳期运动指南：恢复身材不耽误喂奶',
    category: 'xinshou-mama',
    categoryName: '新手妈妈',
    excerpt: '产后想恢复身材又怕影响奶水？科学运动漫画帮你两全其美！',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20fit%20nursing%20mother%20doing%20gentle%20yoga%20exercise%20at%20home%20with%20baby%20nearby%20in%20a%20bright%20living%20room%20soft%20pastel%20colors%20healthy%20lifestyle%20manga%20aesthetic&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '产后恢复组',
    date: '2026-08-03',
    readTime: '9分钟',
    tags: ['产后运动', '身材恢复', '哺乳期健身'],
  },
  {
    id: '12',
    slug: 'buru-yinshi-jinji',
    title: '哺乳期饮食禁忌清单：这些食物要当心',
    category: 'muru-weiyang',
    categoryName: '母乳喂养',
    excerpt: '哺乳期有些食物会影响奶水质量甚至宝宝健康。这份漫画清单一定要收藏！',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20various%20food%20items%20with%20check%20and%20cross%20marks%20showing%20which%20foods%20are%20safe%20for%20breastfeeding%20mothers%20cute%20educational%20style%20soft%20pastel%20colors%20clean%20layout&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '营养科普小组',
    date: '2026-08-01',
    readTime: '10分钟',
    tags: ['饮食禁忌', '哺乳期饮食', '妈妈健康'],
  },
];

export const faqs = [
  {
    question: '奶水不够怎么办？如何增加奶量？',
    answer: '奶水不足是很多新手妈妈的共同困扰。首先，要确认是否真的奶水不足——观察宝宝的尿布数量、体重增长和吃奶后的满足感是更好的判断标准。增加奶量的有效方法包括：增加亲喂频率、确保正确含乳姿势、充分休息和补充水分、合理饮食营养均衡。我们的《追奶全攻略》漫画系列有更详细的指导哦！',
  },
  {
    question: '哺乳期可以化妆和染发吗？',
    answer: '哺乳期适度化妆一般没有问题，但建议选择成分温和、无刺激的化妆品，避免使用含铅和重金属的产品。至于染发，建议等到宝宝满3个月后再进行，选择植物性染发剂，并在通风良好的环境下操作。最重要的是，染发后要彻底清洗，避免化学残留接触宝宝的皮肤。',
  },
  {
    question: '宝宝吃奶频繁是正常的吗？',
    answer: '非常正常！新生儿胃容量很小，需要频繁进食。前几个月的宝宝通常2-3小时就要吃一次奶，有时甚至更频繁，这被称为"集群喂养"。特别是在猛长期（大约在出生后2-3周、6周、3个月和6个月），宝宝会更频繁地要求吃奶。只要宝宝精神好、体重增长正常，无须担心！',
  },
  {
    question: '哺乳期感冒了还能喂奶吗？',
    answer: '可以继续喂奶！妈妈感冒时，体内会产生相应的抗体，这些抗体会通过母乳传递给宝宝，反而能增强宝宝的免疫力。但要注意：喂奶前要洗手，可以佩戴口罩减少飞沫传播，保持房间通风。如果服用药物，请先咨询医生选择哺乳期安全的药物。',
  },
  {
    question: '奶水动漫的内容适合什么年龄段的妈妈？',
    answer: '奶水动漫的内容覆盖从备孕期到宝宝2岁的完整阶段。无论你是正在备孕、孕期中、刚生完宝宝的产后妈妈，还是正在经历哺乳期的新手妈妈，都能在我们这里找到适合你的内容。我们的漫画语言通俗易懂，即使是完全没有育儿经验的准妈妈也能轻松理解！',
  },
  {
    question: '如何判断宝宝是否吃饱了？',
    answer: '判断宝宝是否吃饱有几个关键信号：每天有6-8块湿透的尿布；大便颜色从黑色胎便过渡到黄色软便；宝宝吃奶后显得满足放松，自动松开乳头；体重稳定增长（每周约150-200克）；清醒时精神活跃，反应灵敏。记住，哭闹不一定等于饥饿，也可能是困了、需要抱抱或换尿布哦！',
  },
];

export const testimonials = [
  {
    name: '小月妈妈',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20of%20a%20young%20Chinese%20mother%20with%20a%20gentle%20smile%20soft%20pastel%20color%20palette%20simple%20clean%20background%20manga%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '作为新手妈妈，哺乳这件事真的让我很焦虑。直到发现了奶水动漫，那些可爱的漫画把哺乳知识讲得特别清楚，我现在已经成为忠实粉丝了！',
    rating: 5,
    babyAge: '宝宝3个月',
  },
  {
    name: '豆豆妈妈',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20of%20a%20happy%20Chinese%20woman%20with%20warm%20expression%20soft%20pastel%20tones%20simple%20background%20manga%20portrait&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '科普漫画板块太棒了！以前看文字版的哺乳知识总觉得枯燥，换成漫画形式后一下子就记住了。推荐给所有准妈妈和新手妈妈！',
    rating: 5,
    babyAge: '宝宝6个月',
  },
  {
    name: '糖糖妈妈',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20portrait%20of%20a%20young%20Chinese%20mother%20with%20a%20bright%20smile%20gentle%20expression%20pastel%20colors%20clean%20manga%20style%20portrait&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '萌宝成长动画系列是我和宝宝的最爱！每次放给宝宝看，他都会安静下来专注地盯着屏幕，画面太治愈了。',
    rating: 5,
    babyAge: '宝宝8个月',
  },
];

export const stats = [
  { label: '原创漫画', value: '500+', icon: 'ri-artboard-line' },
  { label: '服务妈妈', value: '100万+', icon: 'ri-user-heart-line' },
  { label: '科普文章', value: '2000+', icon: 'ri-book-open-line' },
  { label: '合作专家', value: '50+', icon: 'ri-team-line' },
];